import React from "react";
import { motion } from "framer-motion";
import ImageGallery from "../Components/Common/ImageGallery";
import Banner from "../Utils/Banner";

const Gallery = () => {
  // Animation variants
  const pageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.3,
        ease: "easeOut"
      }
    }
  };

  return (
    <>
      <motion.div
        className="bg-contain bg-no-repeat bg-gray-200"
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
        variants={pageVariants}
        initial="hidden"
        animate="visible"
      >
        <Banner title="Image Gallery" imageUrl="/assets/Second_Banner.png" />

        <motion.div 
          className="mx-auto ml-4 mr-4 md:ml-6 md:mr-6 lg:mr-14 lg:ml-14  xl:ml-32 xl:mr-32 mb-10 mt-10"
          variants={contentVariants}
          initial="hidden"
          animate="visible"
        >
          <ImageGallery />
        </motion.div>
      </motion.div>
    </>
  );
};

export default Gallery;
